// Meta Pixel utility — loads and tracks events for Facebook Pixel
const PIXEL_ID = '2531039484023610'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Stub fbq before the real script loads so calls can queue up
  const w = window as any
  if (w.fbq) {
    // already present
  } else {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Safely inject the Meta Pixel script into <head>
  try {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const parent = document.head || document.body || document.documentElement
    if (parent) {
      parent.appendChild(script)
    }
  } catch (err) {
    // Fail silently — pixel is non-critical for the page experience
    // eslint-disable-next-line no-console
    console.warn('Meta Pixel failed to load', err)
  }

  w.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'PageView')
  }
}

export function trackAddToCart(data?: Record<string, any>) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', data)
  }
}
